import { useMemo } from 'react';
import { useStoreContextStore } from '../../store/storeContextStore';

export const ALL_STORES_OPTION_VALUE = '__all__';

export const isAllStoresSelection = (store) => (
  Boolean(store?.isAllStores)
  || String(store?.storeInfoId || store?.store_info_id || '') === ALL_STORES_OPTION_VALUE
  || String(store?.vendorId || store?.vendor_id || '').toLowerCase() === 'all'
);

/** Resolve BI vendor filter from the header store selector. */
export const useBiVendorId = () => {
  const selectedStore = useStoreContextStore((state) => state.selectedStore);
  const storeLabel = useMemo(() => {
    if (!selectedStore) return 'No store selected';
    if (isAllStoresSelection(selectedStore)) return 'All Stores';
    return selectedStore.name || selectedStore.storeCode || 'Selected store';
  }, [selectedStore]);

  const vendorId = useMemo(() => {
    if (!selectedStore || isAllStoresSelection(selectedStore)) return 'combined';
    return selectedStore.vendorId || selectedStore.vendor_id || 'combined';
  }, [selectedStore]);

  return { vendorId, storeLabel, selectedStore };
};
